<template lang="html">
  <component
    :is="is"
    type="button"
    class="auth__form-submit"
    :class="{
      disabled: disabled,
      w100: w100,
      'purchases__button--white': color === 'white',
      'purchases__button--green-outline': color === 'green-outline'
    }"
    :disabled="disabled"
  >
    {{ label }}
  </component>
</template>

<script lang="js">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ButtonForm',
  props: {
    is: {
      type: String,
      required: false,
      default: 'button',
    },
    label: {
      type: String,
      required: true,
    },
    disabled: Boolean,
    w100: Boolean,
    color: {
      type: String,
      default: 'green',
      validator: (value) => ['green', 'white', 'green-outline'].includes(value),
    },
  },
});
</script>

<style lang="scss">
.auth__form-submit.disabled:active {
  background: $color-green-disabled;
  border: 2px solid $color-green-disabled;
  color: $color-white;
}

.purchases__button--white.disabled {
  color: $color-green-primary;
  background: $color-white;
  border: 2px solid $color-white;
  opacity: 0.8;
  pointer-events: none;
}

.w100 {
  width: 100%;
}

.purchases__button--green-outline {
  border: 2px solid #359652;
  background-color: white;
  color: #359652;

  &:hover {
    background-color: #359652;
    border-color: #359652;
    color: white;
  }

  &.disabled,
  &.disabled:active
  {
    border: 2px solid #359652;
    background-color: white;
    color: #359652;
    opacity: 0.5;
  }
}
</style>
